import { render, staticRenderFns } from "./OrgEmailBounces.vue?vue&type=template&id=38e1d225&"
import script from "./OrgEmailBounces.vue?vue&type=script&lang=js&"
export * from "./OrgEmailBounces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports